/*
 * @Descripttion:
 * @version:
 * @Author: wanglikun
 * @Date: 2023-08-17 10:17:48
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-13 11:07:31
 */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import routerBefore from './routerBefore'
import { packageManagement, sysSetting } from './route'
import { NameEnum, UrlEnum, UnionEnum } from '@/utils/enums/Route'
const Layout = () => import('@/layout/index.vue')
const Login = () => import('@/views/login/Index.vue')
const findPwd = () => import('@/views/findPwd/Index.vue')

const routes: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.Home],
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: UrlEnum[UnionEnum.ABNORMALPAYMENT],
        name: 'AbnormalPayment',
        component: () => import('@/views/abnormalPayment/Index.vue'),
        meta: { title: NameEnum[UnionEnum.ABNORMALPAYMENT], requiresAuth: true, keepAlive: true }
      },
      {
        path: UrlEnum[UnionEnum.Home],
        name: 'Home',
        component: () => import('@/views/home/myHome.vue'),
        meta: { title: NameEnum[UnionEnum.Home], requiresAuth: true, keepAlive: true }
      },
      {
        path: UrlEnum[UnionEnum.DownLoad],
        name: 'DownLoadCenter',
        component: () => import('@/views/download/Index.vue'),
        meta: { title: NameEnum[UnionEnum.DownLoad], requiresAuth: true, keepAlive: true }
      },
      {
        path: UrlEnum[UnionEnum.NOTFOUND],
        name: 'NotFound',
        component: () => import('@/views/notfound/Index.vue'),
        meta: { title: NameEnum[UnionEnum.NOTFOUND], requiresAuth: true, keepAlive: true }
      },
      {
        path: UrlEnum[UnionEnum.NOAUTH],
        name: 'NoAuth',
        component: () => import('@/views/noauth/Index.vue'),
        meta: { title: NameEnum[UnionEnum.NOAUTH], requiresAuth: true, keepAlive: true }
      },
      // {
      //   path: '/temp',
      //   name: 'temp',
      //   component: () => import('@/print/tmp74_80/index.vue'),
      //   meta: { title: '打印模版预览', requiresAuth: false, keepAlive: false }
      // },
      {
        path: '/yoyiInformation',
        name: 'YoyiInformation',
        component: () => import('../views/manageCenter/yoyiInformation/yoyiInformation.vue'),
        meta: { title: '信息发送管理', requiresAuth: true, keepAlive: true }
      },
      ...packageManagement,
      ...sysSetting
    ]
  },
  {
    path: UrlEnum[UnionEnum.LOGIN],
    name: 'Login',
    component: Login,
    meta: { title: NameEnum[UnionEnum.LOGIN], requiresAuth: false, keepAlive: false }
  },
  {
    path: UrlEnum[UnionEnum.FINDPASSWORD],
    name: 'findPwd',
    component: findPwd,
    meta: { title: NameEnum[UnionEnum.FINDPASSWORD], requiresAuth: false, keepAlive: false }
  },
  {
    path: '/:w+',
    name: '*',
    redirect: UrlEnum[UnionEnum.NOTFOUND]
  }
  // {
  //   path: '',
  //   redirect: UrlEnum[UnionEnum.Home]
  // }
]

const index = createRouter({
  history: createWebHistory(),
  routes
})
//路由导航
routerBefore(index)

export default index
